const styles = `:host {
  /* Using !important here is necessary. The most common reason is for MUI to add
    * { box-sizing: content-box; }
    and that will override any
    :host { box-sizing: border-box }
    in our code
  */
  box-sizing: border-box !important;
  border-width: 1px;
  border-style: solid;
  outline: 0;
  cursor: pointer;
  border-color: transparent;
  display: inline-flex;
  align-items: center;
  height: 36px;
  padding: 0 var(--goto-spacing-05);
  box-sizing: border-box;
  outline: none;
}
:host .control {
  align-items: center;
  display: inline-flex;
  text-decoration: none;
  width: 100%;
}
:host .control .content {
  font: var(--goto-body-small);
  color: var(--goto-text-01);
  display: block;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
:host .control [name=start]::slotted(*) {
  margin-right: var(--goto-spacing-04);
}
:host .control [name=end]::slotted(*) {
  margin-left: var(--goto-spacing-04);
}
:host .control [name=start],
:host .control [name=end] {
  --goto-icon-size: var(--goto-spacing-04);
  --goto-icon-color: var(--goto-text-02);
}
:host .control .start,
:host .control .end {
  align-items: center;
  display: flex;
}
:host .control ::slotted(svg) {
  color: var(--goto-text-02);
  height: var(--goto-spacing-04);
  width: var(--goto-spacing-04);
}

:host(:not([disabled]):focus-visible) {
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight);
}

:host(:hover) {
  background-color: var(--goto-hover-secondary);
}

:host(:active) {
  background-color: var(--goto-pressed-secondary);
}

:host([selected]) {
  background-color: var(--goto-nav-drawer-item-background-selected);
}
:host([selected]) .content {
  color: var(--goto-text-04);
  --goto-icon-color: var(--goto-text-04);
}
:host([selected]) [name=start],
:host([selected]) [name=end] {
  --goto-icon-color: var(--goto-text-04);
}
:host([selected]) ::slotted(svg) {
  color: var(--goto-text-04);
}

:host([size=small]) {
  height: var(--goto-spacing-06);
}
:host([size=small]) .content {
  font: var(--goto-caption-default-01);
}

:host([size=large]) {
  height: 44px;
  margin: 0.25rem 0.5rem;
  border-radius: 4px;
  padding: 0 12px;
}
:host([size=large]) .content {
  font: var(--goto-body-medium);
}`; export default styles;